import { sliderStyles as fastSliderStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationSliderStyles = (context, definition) => css `
  ${fastSliderStyles(context, definition)}
  .track-progress {
    background-color: var(--accent-fill-rest);
    border-radius: calc(var(--control-corner-radius) * 1px);
  }
`;
